import { Wrapper } from "./style";

const Container = ({ children }) => {
  return <Wrapper>{children}</Wrapper>;
};

export default Container;
